import MobileAppSection from "../../components/pages/home/mobile-app-section/MobileAppSection";
import TitleUpdater from "../../components/shared/title/TitleUpdater";
const UserAgreement = () => {
  return (
    <div id="this_page">
      <TitleUpdater title="Colibri | İstifadəçi razılaşması" />
      <div className="container">
        <h1 className="page_title">İstİfadəçİ razılaşması</h1>
        <div className="this_page">
          <h1 className="content_title">
            Malların sifariş et xidmətinə dair şərtlər toplusu:
          </h1>
          <div className="page_content">
            1. "Colibri" MMC (bundan sonra “Daşıyıcı”) satıcı firma deyil və heç
            bir satış xidməti göstərmir. Şirkət sifarişçinin ödənişini birbaşa
            əməkdaşlıq etdiyi Türkiyə şirkətinin bank hesabına köçürür. Sifariş
            verilmə prosesi üçün 3%bank xərci nəzərdə tutulub (Müştərinin
            ödədiyi məbləğin satıcı mağazanın hesabına köçürülməsinə qədərki
            bank xərcləri). <br />
            2. TL balansında sifarişin qiyməti qədər məbləğ olduqda qapıda
            sifariş qəbul olunur. 3. Standard sifarişlər növbəli <br />
            qaydada icra edilir. Sifarişin verilmə müddəti sifariş sayından
            asılı olaraq dəyişə bilir.
            <br /> 4. "Daşıyıcı” heç bir halda satıcı firmanın göndərdiyi
            məhsulun keyfiyyətinə, tamlığına, tərkibinə, ölçü və formasına,
            satış anbarında tükənməsinə və ya sifarişin satıcı tərəfindən ləğv
            olunmasına görə məsuliyyət daşımır. 5. "Daşıyıcı” satıcı firma
            tərəfindən malın onun anbarına çatdırılması müddətinə görə heç bir
            məsuliyyət daşımır. <br /> 6. "Daşıyıcı” sifariş verildikdən sonra
            sifariş üzərində heç bir əməliyyat aparmır (Məhsulun ləğv olunması,
            rəng və ya ölçünün dəyişməsi və s. dəyişikliklər).
            <br /> 7. "Daşıyıcı” sifarişlərin verilməsini növbəli sistemlə
            həyata keçirir. İstifadəçinin eyni saytdan verdiyi sifarişlər
            sayından asılı olmayaraq eyni anda (eyni səbətə əlavə olunaraq )
            verilir. Lakin bəzi satıcı firmalar sifarişləri daşıma şirkətinə
            daha sürətlə çatdırmaq üçün eyni sifarişçinin bir neçə yükünü
            müxtəlif vaxtlarda və fərqli bağlamalarda göndərə bilir. <br /> 8.
            Müştərilərə sifariş vermədən öncə satıcı firmalar haqqında istifadə
            rəyləri ilə tanış olmaları (məsələn, www.sikayetvar.com tipli
            saytlardan) və yaşanacaq problemlər barədə əvvəlcədən
            məlumatlanmaları tövsiyə olunur. <br /> 9. Endirim kuponları və ya
            kampaniyalarla bağlı istifadəçi link göndərərkən qeyd hissəsində
            məlumat verməlidir. Qeyd olmadığı təqdirdə, endirimlərin nəzərə
            alınmama ehtimalı ola bilər. <br /> 10. Müştəri ödəniş edərkən
            Türkiyədaxili karqo ödənişini etmədiyi halda, bu məbləğ onun
            balansına mənfi olaraq yazılır və bağlamanın təhvili zamanı alınır.
            <br /> 11. İstifadəçi sifariş üçün link göndərən zaman məhsulla
            bağlı məlumatları müvafiq xanalara doğru şəkildə qeyd etməlidir.
            Sifariş icra edilərkən müştərinin müvafiq xanalara daxil etdiyi
            məlumatlar əsas kimi götürüləcək (Misalçün, rəng xanasına “qırmızı”,
            əlavə qeydlər bölməsində “yaşıl” yazılırsa, “qırmızı” rəng əsas
            götürüləcək). <br /> 12. Sifariş prosesində hər hansı problem
            yarandıqda (məhsulun bitməsi, sifariş olunan ölçünün bitməsi,
            kampaniyanın başa çatması, ödəmə problemi və s.) sifarişçiyə bu
            haqda məlumat verilir və onun ödədiyi məbləğ Türkiyə şirkəti
            tərəfindən geri qaytarılır. <br />
            13. Sifariş olunmuş məhsulun ödənişi hər hansı səbəbdən geri
            qaytarılarsa, 3% bank xərci geri ödənilmir. <br /> 14. Sifariş
            "Daşıyıcı” tərəfindən icra edildikdən sonra satıcı mağaza tərəfindən
            iptal olunarsa, anbara çatdırılmazsa, karqoya verilmə müddəti
            uzanarsa, bu zaman müştərinin həmin məhsula görə ödədiyi məbləğ eyni
            valyuta ilə geri qaytarılır. Bu halda yaranan məzənnə fərqinə görə
            "Daşıyıcı” məsuliyyət daşımır və bu fərqi müştəriyə ödəmir.
            Sifarişçidən bütün ödənişlər Türkiyə lirəsi ilə qəbul edilir və eyni
            valyuta ilə geri qaytarılır. Digər valyuta və ya məzənnə fərqi ilə
            bağlı yaranan problemlər sifarişçinin bankı ilə
            dəqiqləşdirilməlidir. <br /> 15. Sifarişçinin nəzərinə çatdırılır
            ki, bəzi hallarda bir çox satıcı mağazada məhsulun rənginə və ya
            ölçüsünə görə qiymət fərqi yarana bilər. Belə sifarişlərin icrası
            zamanı arada yaranan qiymət fərqi böyük olmadıqda, sifariş
            "Daşıyıcı” tərəfindən icra edilir və həmin fərq istifadəçinin
            balansına mənfi olaraq yazılır. Ölçü və rəngə görə yaranan qiymət
            fərqi böyük olduqda "Daşıyıcı” bu barədə sifarişçini
            məlumatlandırır. <br /> 16. Sifariş ilə bağlı yaşanmış hər hansı
            problem zamanı sifarişçiyə SMS və ya zəng vasitəsi ilə məlumat
            verilir. Əgər sifarişçi ilə əlaqə yaradıla bilmirsə, sifariş həyata
            keçirilmir. <br /> 17. Sifarişləri səbətə topladıqdan sonra Toplam
            ödə funksiyası ilə ödənilmiş sifarişlər birlikdə verilir.
            Ayrı-ayrılıqda ödəniş olunmuş sifarişlər fərqli vaxtlarda sifariş
            verilə bilər. <br /> 18. Ödənişlərin karta geri qaytarılması 2-15
            gün müddətində baş verir və bank tərəfindən komissiya tutula bilər .
            Bəzi hallarda isə banklardan asılı olaraq, daha bir neçə gün gecikmə
            ola bilir. <br /> 19. Azərbaycan qanunvericiliyi ilə qadağan olunmuş
            məhsulların sifarişi qəbul olunmur. <br /> 20. “Daşıyıcı” tərəfindən
            mobil telefonların sifarişi qəbul edilmir və daşınması həyata
            keçirilmir. Sui-istifadə edib, telefon sifariş etmiş fiziki
            şəxslərin bağlamasının daşınması icra edilmir, həmin bağlamaya görə
            “Daşıyıcı” üzərinə heç bir məsuliyyət götürmür. <br /> 21.
            "Daşıyıcı” dərman preparatlarının sifarişini və daşınmasını həyata
            keçirmir. <br /> 22. Satıcı mağaza tərəfindən “Daşıyıcı”nın anbarına
            gec göndərilmiş və ya göndərilməmiş, səhv müştəri kodu və ya
            ad-soyadla göndərilmiş sifarişlərin araşdırma müddəti satıcının
            geridönüşü də nəzərə alınmaqla, 7-30 gün davam edə bilər. <br /> 23.
            "Daşıyıcı” bütün istifadəçiləri xidmətdən istifadə etməzdən əvvəl
            daşıma şərtləri ilə tanış olmağa çağırır. Şərtlərlə tanış olmaq üçün
            keçiddən istifadə edə bilərsiniz. 
          </div>
        </div>
      </div>
      <MobileAppSection />
    </div>
  );
};

export default UserAgreement;
